export const esgRatings = [
  0.07018724861650642, 0.5896990001421626, 0.340113751241348,
];

export const esgLevels = {
  behind: [0.0, 2.9],
  average: [2.9, 7.1],
  leader: [7.1, 10.0],
};
